import * as types from './mutation-types'
import * as SupplierTypes from './../supplier/mutation-types'
export const loadData = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/anchor/dashboard`, { params }).then((response) => {
            commit(types.SET_INITIAL_DATA, response.data)
            commit(types.SET_INVOICE_GROUP_COUNT, response.data.invoiceGroupCount)
            commit('supplier/' + SupplierTypes.BOOTSTRAP_SUPPLIERS, response.data.suppliers, { root: true })
            commit(types.GET_INITIAL_DATA, true)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
